import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { MiniPopover } from "@website/ui/mini-popover";
import { RadioGroup } from "@website/ui/radio-group";
import { ReserveCommentFilterItemTypes } from "@website/widget/reserve-comment-popup-scroll/reserve-comment-filter/reserve-comment-filter-item/reserve-comment-filter-item.types";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";
export const ReserveCommentsFilterItem = ({
  startIconName,
  filterName,
  radioItems,
  onLoadFilter,
  isInsideDetail
}: ReserveCommentFilterItemTypes) => {
  const router = useRouter();
  return <div className="relative">
      <Button EndIcon={<MaterialIcon name="arrow_drop_down" />} StartIcon={<MaterialIcon className={`${router?.query?.[`filter_${filterName?.en}`] ? "text-secondary" : "text-on-surface-medium-emphasis"} text-body-1`} name={startIconName} />} color={router?.query?.[`filter_${filterName?.en}`] ? "secondary" : "neutral"} onClick={() => router.push({
      pathname: router.pathname,
      query: {
        ...router.query,
        popover: `filter_${filterName?.en}`
      }
    }, undefined, {
      shallow: true,
      scroll: false
    })} size="small" text={filterName?.fa} variant="round-outline" />
      <MiniPopover animate="bottom" className="right-0" defaultHorizontalPosition="end" onClose={() => router.push({
      pathname: router.pathname,
      query: omit(router?.query, "popover")
    }, undefined, {
      shallow: true,
      scroll: false
    })} open={router.query?.["popover"] === `filter_${filterName?.en}`} title={filterName?.fa}>
        <RadioGroup className="text-subtitle-2 flex-col px-6 py-4" color="secondary" items={radioItems} name={filterName?.en} onChange={event => {
        router.push({
          pathname: router.pathname,
          query: {
            ...omit(router?.query, "popover"),
            [`filter_${filterName?.en}`]: event.target?.value
          }
        }, undefined, {
          shallow: true,
          scroll: false
        });
        return onLoadFilter ? onLoadFilter({
          [filterName?.en]: String(event.target?.value)
        }, isInsideDetail) : null;
      }} value={router?.query?.[`filter_${filterName?.en}`]} />
      </MiniPopover>
    </div>;
};